import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const reopenCookieNotice = () =>
    window.dispatchEvent(new Event("open-cookie-notice"));

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-heading">
        <span>UIGHTPARCEL</span>
        <p>Useful clothes. Clear information.</p>
      </div>
      <div className="footer-content">
        <div className="footer-column">
          <h2 className="footer-title">ABOUT</h2>
          <Link onClick={toTop} to="/about" className="footer-link">
            About us
          </Link>
          <Link onClick={toTop} to="/contact" className="footer-link">
            Contact
          </Link>
          <Link onClick={toTop} to="/accessibility" className="footer-link">
            Accessibility
          </Link>
        </div>
        <div className="footer-column">
          <h2 className="footer-title">HELP</h2>
          <Link onClick={toTop} to="/faqs" className="footer-link">
            FAQs
          </Link>
          <Link onClick={toTop} to="/shipping" className="footer-link">
            Delivery &amp; shipping
          </Link>
          <Link onClick={toTop} to="/returns" className="footer-link">
            Returns
          </Link>
        </div>
        <div className="footer-column">
          <h2 className="footer-title">LEGAL</h2>
          <Link onClick={toTop} to="/terms" className="footer-link">
            Terms of use
          </Link>
          <Link onClick={toTop} to="/privacy" className="footer-link">
            Privacy policy
          </Link>
          <Link onClick={toTop} to="/cookies" className="footer-link">
            Cookie notice
          </Link>
          <Link
            onClick={toTop}
            to="/intellectual-property"
            className="footer-link"
          >
            IP &amp; takedown policy
          </Link>
          <button
            type="button"
            onClick={reopenCookieNotice}
            className="footer-link footer-button"
          >
            Cookie notice settings
          </button>
        </div>
        <div className="footer-column">
          <h2 className="footer-title">CONTACT</h2>

          <p className="footer-link">
            YuTao Wei
            <br />
            yxfdx001@sina.com
            <br />
            XianCunZhenBiYanCun
            <br />
            GuangMingLuSanXiang13Hao
            <br />
            ZhouNingXian
            <br />
            355400
            <br />
            China
            <br />
            Call us: +86 17206912757
          </p>
          <span className="footer-note">
            Please do not email passwords, card details or other sensitive
            information.
          </span>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Uightparcel. All rights reserved.</span>
        <span>Catalogue preview · Payments disabled</span>
      </div>
    </footer>
  );
}

export default Footer;
